<template>
  <van-collapse-item :title="company.companyName"
    :name="company.companyName">
    <template v-slot:title>
      <span class="org-name">{{company.companyName}}</span>
    </template>
    <template v-slot:value>
      <span>关联 <span style="color:#d04a02;">{{company.relationCount}}</span> 条PwC关系</span>
    </template>
    <contractor-item-company v-for="(item,index) in company.members"
      v-bind:key="index"
      :data="item"
      :show-chk="isEdit"
      :show-prefer="showPrefer"
      :show-know="true"
      @cancel="cancelMark"
      :disable-swipe="disableSwipe">
    </contractor-item-company>
  </van-collapse-item>
</template>

<script>
import {
  Dialog
} from 'vant';
import ContractorItemCompany from "./ContractorItemCompany";

export default {
  data () {
    return {
      showPrefer: true,
      isEdit: false,
      disableSwipe: true
    };
  },
  props: {
    company: {
      type: Object,
      required: true,
    }
  },
  components: { ContractorItemCompany },
  computed: {},
  mounted () { },
  methods: {
    cancelMark (id) {
      common.cancelMark(this, id);
    },
  },
};
</script>

<style lang='scss' scoped>
.org-name {
  font-size: 14px;
}

.van-collapse-item .van-cell {
  background-color: #969799;
}
</style>



// WEBPACK FOOTER //
// src/components/content/contractor/ContractorGroupListItemCompany.vue